import React, {useState} from 'react';
import Popup from "./common/components/Popup";
import {Steps} from "./common/constants/constants";
import Loader from "./common/components/Spinner";
import LocationView from "./views/LocationView";
import ReportDataView from "./views/ReportDataView";
import ConfirmView from "./views/ConfirmView";
import StepOverview from "./common/components/StepOverview";
import {GeneralDataInterface} from "./common/interfaces/GeneralDataInterface";
import {LocationDataInterface} from "./common/interfaces/LocationDataInterface";
import {ApplicantDataInterface} from "./common/interfaces/ApplicantDataInterface";
import {ContactPersonDataInterface} from "./common/interfaces/ContactPersonDataInterface";
import {NotificationDataInterface} from "./common/interfaces/NotificationDataInterface";
import {PopupInterface} from "./common/interfaces/PopupInterface";
import FilesUpload from "./common/components/FilesUpload";
import ConfirmedView from "./views/ConfirmedView";
import {Introduction} from "./common/components/Introduction";

function App() {

    const dateTimeFormatOptions: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    };
    const confirmationUrl = document.getElementById('react-repair-form')?.dataset.confirmationUrl || ''
    const [loading, setLoading] = useState(false)
    const [generalData, setGeneralData] = useState<GeneralDataInterface>({
        appReference: 'TEMP-REF',
        requestDate: new Date().toLocaleString('nl-NL', dateTimeFormatOptions)
    })
    const [locationData, setLocationData] = useState<LocationDataInterface>({})

    const [applicantData, setApplicantData] = useState<ApplicantDataInterface>({})
    const [contactPersonData, setContactPersonData] = useState<ContactPersonDataInterface>({isActive: false})
    const [notificationData, setNotificationData] = useState<NotificationDataInterface>({})
    const [popupData, setPopupData] = useState<PopupInterface>({isActive: false})
    const [step, setStep] = useState(Steps.LOCATION)
    const [files, setFiles] = useState([])

    return (
        <>
            <div className="p-repair-form">


                <Introduction step={step}/>

                <div className="c-repair-form">

                    <StepOverview step={step}/>

                    <LocationView
                        step={step}
                        setStep={setStep}
                        generalData={generalData}
                        setGeneralData={setGeneralData}
                        locationData={locationData}
                        setLocationData={setLocationData}
                        setLoading={setLoading}
                        popupData={popupData}
                        setPopupData={setPopupData}
                    />

                    <ReportDataView
                        step={step}
                        setStep={setStep}
                        generalData={generalData}
                        applicantData={applicantData}
                        setApplicantData={setApplicantData}
                        contactPersonData={contactPersonData}
                        setContactPersonData={setContactPersonData}
                        notificationData={notificationData}
                        setNotificationData={setNotificationData}
                        setLoading={setLoading}
                    />

                    <FilesUpload
                        step={step}
                        files={files}
                        setFiles={setFiles}
                        setLoading={setLoading}
                    />

                    <ConfirmView
                        step={step}
                        generalData={generalData}
                        applicantData={applicantData}
                        contactPersonData={contactPersonData}
                        notificationData={notificationData}
                        setLoading={setLoading}
                        setPopupData={setPopupData}
                        setGeneralData={setGeneralData}
                        files={files}
                        setStep={setStep}
                        confirmationUrl={confirmationUrl}
                    />

                    <ConfirmedView
                        step={step}
                    />

                </div>

            </div>

            <Popup popupData={popupData} setPopupData={setPopupData}/>
            <Loader isActive={!!loading}/>

        </>
    )
}

export default App;
